import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import constants from '../constants';
import HandleData from '../utils/HandleData';

function UseAppContext() {
  const [teams, setTeams] = useState([]);
  const [athletes, setAthletes] = useState([]);
  const [handleModal, setHandleModal] = useState({});
  const [handleBannerCartola, setHandleBannerCartola] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [publicOpinion, setPublicOpinion] = useState({});

  const handleAthletes = (data) => {
    setAthletes([
      ...data.map((atleta) => {
        return {
          id: atleta.atleta_id,
          teamId: Number(atleta.equipe),
          name: atleta.nome_popular,
          cartola: String(atleta.cartoletas),
          position: {
            role: atleta.posicao.descricao.split(' ')[0],
            description: atleta.posicao.descricao,
            field: atleta.posicao.macro,
          },
          eval: atleta.avaliacao || 1,
          picture: {
            big: atleta.fotos
              ? atleta.fotos['300x300']
              : 'https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/static_especiais/futebol/copa-do-mundo/especial/avaliador-de-elencos-da-copa-2022/jogador-generico.svg',
            small: atleta.fotos
              ? atleta.fotos['80x80']
              : 'https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/static_especiais/futebol/copa-do-mundo/especial/avaliador-de-elencos-da-copa-2022/jogador-generico.svg',
          },
        };
      }),
    ]);
  };

  const handleTeams = (data) => {
    setTeams([
      ...Object.keys(data).map((key) => {
        const item = data[key];

        return {
          id: item.equipe_id,
          name: item.nome_popular,
          abbr: item.sigla,
          gender: item.genero,
          slug: item.slug,
          emoji: constants.flags[item.equipe_id],
          emblem:
            item.escudos && item.escudos.svg
              ? item.escudos.svg
              : item.escudos['60x60'],
          athletes: item.atletas.map((value) => Number(value)),
        };
      }),
    ]);
  };

  const bindPublicOpinion = (data) => {
    const evalObj = {};
    const evalResponse = (key) => {
      evalObj[key] = 0;
    };
    Object.keys(data).forEach(evalResponse);

    setPublicOpinion({ ...evalObj });
  };

  const getAthlete = (id) => {
    const [athlete] = athletes.filter((item) => item.id === id);
    return athlete;
  };

  const getTeam = (id) => {
    const [team] = teams.filter((item) => item.id === id);
    return team;
  };

  const getPublicOpinion = (id) => {
    const evaluation = publicOpinion[id];
    return evaluation;
  };

  useEffect(() => {
    const handleSuccess = (data) => {
      const atletas = data.atletas;
      const infos = Object.values(atletas).filter((item) => item.avaliacao);

      handleAthletes(infos);
      handleTeams(data.equipes);
      bindPublicOpinion(data.atletas);
      setLoaded(true);
    };

    const handleError = () => {
      setLoaded(false);
    };

    HandleData.get(constants.dataURL, handleSuccess, handleError);
  }, []);

  return {
    handleModal,
    setHandleModal,
    handleBannerCartola,
    setHandleBannerCartola,
    athletes,
    teams,
    publicOpinion,
    getAthlete,
    getTeam,
    getPublicOpinion,
    loaded,
  };
}

export const athletePropTypes = {
  id: PropTypes.number.isRequired,
  teamId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.shape({
    role: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
  }),
  eval: PropTypes.number,
  cartola: PropTypes.string,
  picture: PropTypes.shape({
    big: PropTypes.string.isRequired,
    small: PropTypes.string.isRequired,
  }),
};

export const teamPropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  abbr: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  emblem: PropTypes.string.isRequired,
  athletes: PropTypes.arrayOf(PropTypes.number.isRequired),
};

export const providerPropTypes = {
  value: PropTypes.shape({
    handleModal: PropTypes.object,
    setHandleModal: PropTypes.func,
    handleBannerCartola: PropTypes.object,
    setHandleBannerCartola: PropTypes.func,
    athletes: PropTypes.arrayOf(
      PropTypes.shape({ ...athletePropTypes }).isRequired
    ),
    teams: PropTypes.arrayOf(PropTypes.shape({ ...teamPropTypes }).isRequired),
    openTeams: PropTypes.objectOf(PropTypes.bool),
    publicOpinion: PropTypes.objectOf(PropTypes.number),
    getAthlete: PropTypes.func.isRequired,
    getTeam: PropTypes.func.isRequired,
    getPublicOpinion: PropTypes.func.isRequired,
    loaded: PropTypes.bool.isRequired,
  }),
};

export default UseAppContext;
